import { render, staticRenderFns } from "./FormaPagamentoEdit.vue?vue&type=template&id=02f5586c"
import script from "./FormaPagamentoEdit.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports